import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { File } from 'containers/misc'

export default class Files extends Component {
  static propTypes = {
    urls: PropTypes.array.isRequired,
    decoWithCode: PropTypes.bool,
    decoWithCodeFromUrl: PropTypes.bool
  }
  static defaultProps = {
    urls: [],
    decoWithCode: false,
    decoWithCodeFromUrl: false,
  }

  render() {
    const { urls, decoWithCode, decoWithCodeFromUrl } = this.props

    return (
      <div>
        {urls.map((item, index) => (
          <File key={index} src={item} withAuthCode={decoWithCode} withAuthCodeFromUrl={decoWithCodeFromUrl} clickable />
        ))}
      </div>
    )
  }
}
